import service from '@/service'

/**
 * @description 物流对接列表查询
 */
export function getList(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/getList',
    method: 'post',
    data
  })
}

/**
 * @description 再次对接
 */
export function manualDock(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/manualDock',
    method: 'post',
    data
  })
}

/**
 * @description 标记完成
 */
export function markDone(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/markCompleted',
    method: 'post',
    data
  })
}
/**
 * @description 获取商品明细
 */
export function detailListByOrderCode(params) {
  return service['api-scm']({
    url: '/public/warehouseOrderOut/detailListByOrderCode',
    method: 'get',
    params,
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
/**
 * @description 已处理-未处理导出数据
 */
export function exportData(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/export',
    method: 'post',
    data
  })
}

/**
 * @description 上传回签单图片
 */
export function uploadingImage(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/uploadingImage',
    method: 'post',
    data
  })
}

/**
 * @description 再次对接回签单
 */
export function tautologySign(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/tautologySign',
    method: 'post',
    data
  })
}

/**
 * @description 标记回签单完成
 */
export function batchDispose(data) {
  return service['api-web']({
    url: '/dc/logisticsDockList/dl/batchDispose',
    method: 'post',
    data
  })
}

export { getOrderLog } from '@/service/api-scm/orderManage/orderInfo'

export {
  getList as getOrderOutCodeId,
  info as getOrderOutInfo
} from '@/service/api-scm/sellInOutWarehouse/sellOutWarehouse'

export {
  getList as getSellOrderId,
  info as getSellOrderInfo
} from '@/service/api-web/clientServe/sellManage/sellOrder'
